import { render, staticRenderFns } from "./ReplyCardInput.vue?vue&type=template&id=37ae6ee6&"
import script from "./ReplyCardInput.vue?vue&type=script&lang=js&"
export * from "./ReplyCardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports